import { HTMLAttributes } from 'react';
import styled, { keyframes } from 'styled-components';

import { color } from 'theme/selectors';

const createPulsarKeyframes = (primaryColor: string) => keyframes`
    0% {
      box-shadow: 0 0 0 0 ${primaryColor};
    }

    100% {
        box-shadow: 0 0 0 14px transparent;
    }
`;

export const DownloadButton = styled.a<
    {
        $centered: boolean;
    } & HTMLAttributes<HTMLAnchorElement>
>`
    display: flex;
    justify-content: ${({ $centered }) => ($centered ? 'center' : 'space-between')};
    align-items: center;
    width: 100%;
    height: 64px;
    margin: 0 auto;
    border-radius: 12px;
    padding: 0 20px;
    background-color: ${color('primary-default')};
    font-family: inherit;
    font-size: 17px;
    line-height: 24px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: ${color('surface-main')};
    animation: ${({ theme }) => createPulsarKeyframes(theme['primary-default'])} 2s infinite;
`;
